/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty } from 'lodash';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import Draggable from 'vuedraggable';
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import EventDetailsSection from 'ui/components/registrations/EventDetailsSection.vue';
import HorizontalDivider from 'shared/ui/components/HorizontalDivider.vue';
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';
import InputWithActions from 'shared/ui/components/form-components/InputWithActions.vue';
import RegistrationUrlPicker from 'shared/ui/components/form-components/pickers/RegistrationUrlPicker.vue';
import WarningWallModal from 'ui/components/registrations/WarningWallModal.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

// Mixins
import form from 'ui/components/registrations/form';

const __vue_script__ = {
    name: 'EventDetails',

    components: {
        BaseInput,
        BaseSelect,
        Draggable,
        DropdownMenu,
        EventDetailsSection,
        HorizontalDivider,
        HtmlEditor,
        InputWithActions,
        RegistrationUrlPicker
    },

    mixins: [form],

    props: {
        settings: {
            type: Object,
            default: () => ({})
        },

        eventDetails: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        const localeOptions = this.event.languages?.map(lang => ({
            label: lang.toUpperCase(),
            value: lang
        })) || [];
        if (localeOptions.length > 1 && !localeOptions.find(l => l.value === 'en')) {
            localeOptions.push({ label: this.$t('registration.configuration.default_locale'), value: 'en' });
        }
        const isBetaTester = this.$services.user.isBetaTester();
        return {
            collapsedSections: [],
            // Multilang is not yet supported, and the webapp expect 'en' as default all the time
            currentLang: 'en',
            localeOptions,
            isBetaTester,
            editing: -1,
            ready: false,
            sections: [],
            sectionsEnabled: this.options.eventDetailsSectionsEnabled,
            title: '',
            wallConfig: {
                enabled: false,
                content: {
                    en: ''
                },
                redirect: {
                    en: ''
                }
            }
        };
    },

    watch: {
        sections: {
            deep: true,
            async handler() {
                this.emit();
            }
        },

        value: {
            immediate: true,
            handler() {
                if (this.sectionsEnabled) {
                    const defaultSection = {
                        type: 'editorial',
                        title: { [this.currentLang]: this.$t('registration.configuration.form.section_types.editorial') },
                        content: { [this.currentLang]: '' }
                    };

                    if (!isEmpty(this.innerValue.description)) {
                        // When this metric goes to 0 we can remove this reconciliation snippet
                        this.$services.track.track('legacy_reg_config_reconciliation');
                        defaultSection.content[this.currentLang] = this.innerValue.description;
                        delete this.innerValue.description;
                    }

                    this.sections = this.innerValue.sections || [];
                    this.wallConfig = this.innerValue.warning_wall_config || this.wallConfig;
                }

                this.ready = true;
            }
        }
    },

    methods: {
        /**
         * Adds a new section of the specified type
         *
         * @param {string} type the type of the section to add
         */
        addSection(type) {
            const titleKey = `registration.configuration.form.section_types.${type}`;
            const title = this.$i18n.te(titleKey) ? this.$i18n.t(titleKey) : '';
            const section = {
                type,
                title: {
                    [this.currentLang]: title
                },
                content: {
                    [this.currentLang]: ''
                }
            };
            if (type !== 'editorial') {
                section.ids = [];
            }
            const index = this.sections.length;
            this.$set(this.sections, index, section);

            this.$utils.dom.scrollToId('#event-details-bottom');
        },

        /**
         * Updates a section with the given data
         *
         * @param {object} data the new data to set for the section
         * @param {number} index the index where to find the section to update
         */
        updateSection(data, index) {
            this.$set(this.sections, index, data);
        },

        /**
         * Toggles the specified section
         *
         * @param {string} section the section name to toggle
         */
        toggleSection(section) {
            if (this.collapsedSections.includes(section)) {
                this.collapsedSections = this.collapsedSections.filter(s => s !== section);
            } else {
                this.collapsedSections.push(section);
            }
        },

        /**
         * Starts the section name editing
         *
         * @param {number} index the section index to edit
         */
        rename(index) {
            this.title = this.sections[index].title[this.currentLang];
            this.editing = index;
        },

        /**
         * Prompts the user for the section removal
         *
         * @param {number} index the index of the section to remove
         */
        promptRemoval(index) {
            this.$modal.show('dialog', {
                text: this.$t('registration.configuration.messages.event_section_removal'),
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.confirm'),
                        handler: async () => {
                            this.removeSection(index);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Removes the section from the list
         *
         * @param {number} index the index of the section to remove
         */
        removeSection(index) {
            /** @type {object[]} */
            const sections = this.sections;
            const section = sections[index];

            if (!section) {
                console.warn('[EventDetails] Specified section does not exist', index);
                return;
            }
            sections.splice(index, 1);
        },

        /**
         * Given a section type, gets the correspoding icon CSS class
         *
         * @param {string} sectionType the type of the section
         *
         * @returns {string|null} the icon class to use
         */
        iconClass(sectionType) {
            return this.$utils.assets.getIconForType(sectionType);
        },

        /**
         * Stops the editing of the section title
         */
        stopTitleEditing() {
            this.title = '';
            this.editing = -1;
        },

        /**
         * Sets the title for the section at index
         *
         * @param {number} index the index of the section
         */
        setTitle(index) {
            const section = this.sections[index];
            section.title[this.currentLang] = this.title;

            this.stopTitleEditing();
        },

        hasTitle(section) {
            return !isEmpty(section.title[this.currentLang]);
        },

        /**
         * Validates and emits the new values of the configuration
         */
        async emit() {
            const valid = await this.$refs.form.validate();

            if (valid) {
                this.innerValue.sections = this.sections;
                this.innerValue.warning_wall_config = this.wallConfig;

                this.$emit('input', this.innerValue);
            }
        },

        openWarningWallModal() {
            const config = { ...this.wallConfig };
            this.$modal.show(WarningWallModal, {
                event: this.event,
                config: config,
                onSave: (data) => {
                    this.wallConfig = data;
                    this.emit();
                    this.saveChanges();
                }
            }, { classes: 'small', height: 'auto' });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"event-details",attrs:{"tag":"form","autocomplete":"off"}},[_c('div',{staticClass:"boxed-content"},[(!_vm.event.is_template)?_c('registration-url-picker',{attrs:{"name":"registrationUrl","label":_vm.$t('registration.configuration.form.registration_url_label'),"event":_vm.event},scopedSlots:_vm._u([{key:"after-label",fn:function(){return [_c('div',{staticClass:"control-hint"},[_vm._v(_vm._s(_vm.$t('registration.configuration.form.registration_url_alert')))])]},proxy:true}],null,false,402554552),model:{value:(_vm.innerValue.path_name),callback:function ($$v) {_vm.$set(_vm.innerValue, "path_name", $$v)},expression:"innerValue.path_name"}}):_vm._e()],1),_c('p',[_c('a',{staticClass:"has-action",on:{"click":_vm.openWarningWallModal}},[_vm._v(_vm._s(_vm.$t('registration.configuration.warning_wall')))]),_c('span',{staticClass:"badge",class:{ 'badge-success': _vm.wallConfig.enabled }},[_vm._v(_vm._s(_vm.$t(("general." + (_vm.wallConfig.enabled ? 'enabled' : 'disabled')))))])]),_c('hr',{staticClass:"separator"}),(_vm.sectionsEnabled)?[(_vm.isBetaTester && _vm.localeOptions.length > 1)?_c('base-select',{staticClass:"small",attrs:{"name":"locale","options":_vm.localeOptions,"track-by":"value","emit-option-value-only":"emit-option-value-only","allow-empty":false},model:{value:(_vm.currentLang),callback:function ($$v) {_vm.currentLang=$$v},expression:"currentLang"}}):_vm._e(),_c('div',{staticClass:"heading"},[_c('h5',[_vm._v(_vm._s(_vm.$t('registration.configuration.form.sections.builder')))]),_c('div',{staticClass:"actions"},[_c('dropdown-menu',{attrs:{"anchor-pos":"ne","hide-delay-after-click":0},scopedSlots:_vm._u([{key:"toggler",fn:function(ref){return [_c('button',{staticClass:"btn btn-primary btn-ctx-icon",attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.$t('registration.configuration.actions.add_detail_section'))),_c('i',{staticClass:"ic-plus"})])]}}],null,false,4132679181)},[_c('ul',[_c('li',[_c('a',{on:{"click":function($event){return _vm.addSection('editorial')}}},[_c('i',{staticClass:"ic-file-text"}),_vm._v(_vm._s(_vm.$t('registration.configuration.form.section_types.editorial')))])]),_c('li',[_c('a',{on:{"click":function($event){return _vm.addSection('session')}}},[_c('i',{staticClass:"ic-calendar-agenda"}),_vm._v(_vm._s(_vm.$t('registration.configuration.form.section_types.session')))])]),_c('li',[_c('a',{on:{"click":function($event){return _vm.addSection('presenter')}}},[_c('i',{staticClass:"ic-mic-outline"}),_vm._v(_vm._s(_vm.$t('registration.configuration.form.section_types.presenter')))])]),_c('li',[_c('a',{on:{"click":function($event){return _vm.addSection('sponsor')}}},[_c('i',{staticClass:"ic-in-person"}),_vm._v(_vm._s(_vm.$t('registration.configuration.form.section_types.sponsor')))])])])])],1)]),(_vm.ready)?_c('draggable',{attrs:{"filter":".html-editor","preventOnFilter":false},on:{"start":function($event){return _vm.stopTitleEditing()}},model:{value:(_vm.sections),callback:function ($$v) {_vm.sections=$$v},expression:"sections"}},_vm._l((_vm.sections),function(section,index){return _c('event-details-section',{key:((section.type) + "-" + index),class:{collapsed: _vm.collapsedSections.includes(index)},attrs:{"event":_vm.event,"lang":_vm.currentLang,"value":section,"type":section.type},on:{"input":function (data) { return _vm.updateSection(data, index); }},scopedSlots:_vm._u([{key:"top-header",fn:function(){return [(_vm.editing !== index)?_c('div',{staticClass:"title-and-actions"},[_c('div',{staticClass:"actions"},[(section.has_anchor)?_c('span',{staticClass:"in-nav"},[_vm._v(_vm._s(_vm.$t('registration.configuration.section_has_anchor')))]):_vm._e(),_c('a',{staticClass:"toggler",on:{"click":function($event){return _vm.toggleSection(index)}}},[_c('i',{staticClass:"ic-chevron-up"})]),_c('dropdown-menu',{staticClass:"embedded"},[_c('ul',[_c('li',[_c('a',{staticClass:"has-action rename",on:{"click":function($event){$event.preventDefault();return _vm.rename(index)}}},[_c('i',{staticClass:"ic-edit"}),_vm._v(_vm._s(_vm.$t('registration.configuration.actions.rename')))])]),_c('li',[_c('a',{staticClass:"has-action delete danger",on:{"click":function($event){$event.preventDefault();return _vm.promptRemoval(index)}}},[_c('i',{staticClass:"ic-trash-2"}),_vm._v(_vm._s(_vm.$t('registration.configuration.actions.remove')))])])])])],1),_c('div',{staticClass:"drag-handler"},[_c('i',{staticClass:"icon-reorder"})]),(_vm.hasTitle(section))?_c('span',{staticClass:"title"},[_c('i',{class:_vm.iconClass(section.type)}),_vm._v(_vm._s(section.title[_vm.currentLang]))]):_c('span',{staticClass:"title empty"},[_c('i',{class:_vm.iconClass(section.type)}),_vm._v(_vm._s(_vm.$t('registration.configuration.no_title_set')))])]):_c('div',{staticClass:"title-and-actions editing"},[_c('validation-provider',{attrs:{"slim":true,"name":"title"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-with-actions',{attrs:{"type":"text","name":"title","placeholder":_vm.$t('registration.configuration.new_event_section_placeholder'),"errors":errors,"focused":_vm.ready},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.stopTitleEditing()}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.setTitle(index)}}},[_vm._v(_vm._s(_vm.$t('general.accept')))])])]}}],null,true)})],1)]},proxy:true}],null,true)})}),1):_vm._e(),(_vm.ready && _vm.sectionsEnabled && !_vm.sections.length)?_c('div',{staticClass:"empty-state"},[_c('p',[_vm._v(_vm._s(_vm.$t('registration.configuration.form.no_sections')))])]):_vm._e()]:[_c('validation-provider',{attrs:{"slim":true,"name":"description"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('html-editor',{attrs:{"event-id":_vm.event._id,"name":"description","label":_vm.$t('registration.configuration.form.description'),"links":true,"enable-custom-bstg-links":false,"extras":false,"images":true,"errors":errors,"blockquote":true},model:{value:(_vm.innerValue.description),callback:function ($$v) {_vm.$set(_vm.innerValue, "description", $$v)},expression:"innerValue.description"}})]}}])})],_c('div',{attrs:{"id":"event-details-bottom"}})],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EventDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__